import React from 'react';
import { formatSectionTitle, getSectionIcon } from '../../../utils/formatters';

const ReportTimeline = ({ sections, activeSection, onSectionClick }) => {
  return (
    <div className="timeline-navigation">
      <h4>📋 Report Sections</h4>
      <div className="timeline-items">
        {sections.map((section, index) => (
          <div
            key={index}
            className={`timeline-item ${activeSection === index ? 'active' : ''}`}
            onClick={() => onSectionClick(index)}
          >
            <div className="timeline-marker">
              <span className="timeline-icon">{getSectionIcon(section.section_type)}</span>
            </div>
            <div className="timeline-content">
              <h5>{formatSectionTitle(section.section_type)}</h5>
              <span className="timeline-progress">Section {index + 1}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportTimeline;
